module.exports = __webpack_public_path__ + "static/media/arrow-down.514dc7ec.svg";